import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { EditableBoardSharePrivateLink } from "~/components/SharePrivateBoardModal/EditableBoardSharePrivateLink";
import { useUpdateShareBoardLink } from "~/components/SharePrivateBoardModal/hooks/useUpdateShareBoardLink";
import { EnableSharedLinkToggle } from "~/components/SharePrivateContentModal/EnableSharedLinkToggle";
import { EnableShareLinkDownloadToggle } from "~/components/SharePrivateContentModal/EnableShareLinkDownloadToggle";
import { SharePrivateContentExpirationDateDisplay } from "~/components/SharePrivateContentModal/SharePrivateContentExpirationDateDisplay";
export const SharePrivateBoardLinkInfo = /*#__PURE__*/ memo((param)=>{
    let { shortIdInfo, boardId, trackLocation, goToSettings, userPermissions } = param;
    const { onShortUrlUpdate, isLoading } = useUpdateShareBoardLink({
        boardId,
        shortIdInfo
    });
    const onToggleEnableLink = useCallback((enabled)=>onShortUrlUpdate({
            disabled: !enabled
        }), [
        onShortUrlUpdate
    ]);
    const onDownloadToggle = useCallback((enabled)=>onShortUrlUpdate({
            permissions: {
                asset: {
                    canViewOriginal: enabled
                }
            }
        }), [
        onShortUrlUpdate
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-3",
        children: [
            /*#__PURE__*/ _jsx(EnableSharedLinkToggle, {
                enabled: !shortIdInfo.disabled,
                isLoading: isLoading,
                onToggle: onToggleEnableLink
            }),
            !shortIdInfo.disabled && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(EnableShareLinkDownloadToggle, {
                        checked: shortIdInfo.permissions.asset.canViewOriginal,
                        isLoading: isLoading,
                        onToggle: onDownloadToggle,
                        infoText: "Assets in this board can be downloaded or saved to other Air workspaces",
                        disabled: !userPermissions.asset.canViewOriginal
                    }),
                    /*#__PURE__*/ _jsx(EditableBoardSharePrivateLink, {
                        boardId: boardId,
                        trackLocation: trackLocation,
                        shortIdInfo: shortIdInfo
                    }),
                    !!shortIdInfo.expirationDate && /*#__PURE__*/ _jsx(SharePrivateContentExpirationDateDisplay, {
                        expirationDate: shortIdInfo.expirationDate,
                        goToAdvancedSettings: goToSettings
                    })
                ]
            })
        ]
    });
});
SharePrivateBoardLinkInfo.displayName = "SharePrivateBoardLinkInfo";
